import { LazyLoad } from 'features/common/ui/LazyLoad'
import { lazy } from 'app/lazy'

const ErrorPage = lazy(() => import('./ErrorPage'))

const routes = [
  {
    path: '500',
    element: (
      <LazyLoad>
        <ErrorPage code="500" />
      </LazyLoad>
    )
  },
  {
    path: '*',
    element: (
      <LazyLoad>
        <ErrorPage code="404" />
      </LazyLoad>
    )
  }
]

export default routes
